//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-unreachable */
import { mapMutations, mapState } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import QAuModelPicker from "@/components/Generics/ModelPicker/qAuModelPicker.vue";

export default {
    name: "QfPDataModel",
    components: { AQCard, AQModal, AQButton, QAuModelPicker },
    props: {
        fromDiagram: {
            type: Boolean,
            default: false
        },
        diagramSavedFilename: {
            type: String,
            default: null
        },
        readOnly: {
            type: Boolean,
            default: false
        }

    },
    data() {
        return {
            showModal: false,
            headerActions: [
                { label: this.$t("blockchainBuilder.delete"), name: "delete", disabled: false }
            ],
            selection: [],
            showDataModel: true,
            selectedDataModel: null,
            dataModelArray: [],
            documentName: "",
            selectedField: null,
            filenameNoChip: null,
            loadComplete: false,
            savedRange: null
        };
    },
    computed: {
        ...mapState("components", ["fileNameWithDataModel"]),
        doneModal() {
            return { label: this.$t("generic.done") };
        }

    },
    mounted() {
        this.initializeData();
    },
    methods: {
        ...mapMutations("components", ["setFileNameWithDataModel"]),
        ...mapMutations("diagrams", ["setDiagramFileNameWithDataModel"]),
        addDataModel() {
            this.showModal = true;
        },
        modalAction($event) {
            if ($event === "primary") {
                if (this.selectedField) {
                    this.addChipToInput(this.selectedField);
                }
                this.$emit("input", false);
                this.showModal = false;
            } else if ($event === "close") {
                this.showModal = false;
                this.$emit("input", false);
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        dataModelSelect(field) {
            this.selectedField = field;
        },
        initializeData() {
            let rawString;
            if (this.fromDiagram && this.diagramSavedFilename) {
                rawString = this.diagramSavedFilename;
            } else if (this.fromDiagram && !this.diagramSavedFilename) {
                rawString = null;
            } else if (!this.fromDiagram) {
                rawString = this.fileNameWithDataModel;
            }
            if (rawString) {
                if (rawString.includes("${(")) {
                    const savedFilename = rawString;
                    const formattedFilename = savedFilename.split(/\${|!}/);
                    const newList = [];
                    this.dataModelArray = [];
                    formattedFilename.forEach(elem => {
                        if (elem.charAt(0) === "(" && elem.charAt(elem.length - 1) === ")") {
                            this.dataModelArray.push(elem.slice(1, -1));
                            const adaptedString = elem.slice(3, -1);
                            const addChip = this.addVarInChip(adaptedString);
                            newList.push(addChip);
                        } else {
                            newList.push(elem);
                        }
                        this.documentName = newList.join("");
                    });
                } else {
                    this.documentName = rawString;
                }
            } else {
                this.documentName = "export ";
            }
            this.loadComplete = true;
        },
        addChipToInput(field) {
            const chip = this.createChip(field[0].key);
            this.dataModelArray.push(field[0].formatted);
            if (this.savedRange) {
                this.savedRange.insertNode(chip);
            } else {
                this.$refs.mainInput.appendChild(chip);
            }
            chip.insertAdjacentHTML("afterend", "&nbsp;");
            this.updateInput();
        },
        createChip(data) {
            const template = document.createElement("template");
            template.innerHTML = `<span class="dm-chip" contenteditable="false">${data}</span>&nbsp;`;
            return template.content.firstChild;
        },
        addVarInChip(data) {
            return `<span class="dm-chip" contenteditable="false">${data}</span>&nbsp;`;
        },
        updateInput() {
            this.filenameNoChip = this.$refs.mainInput.innerText;
            const content = this.$refs.mainInput.innerHTML;
            this.documentName = content;
            if (!this.documentName) {
                this.documentName = "export";
                this.filenameNoChip = "export";
            }
            this.createFileName();
        },
        selectChanged() {
            const selection = window.getSelection();
            if (selection.baseNode.parentElement === this.$refs.mainInput) {
                const range = selection.getRangeAt(0);
                this.savedRange = range;
            }
        },
        createFileName() {
            if (this.documentName.includes('class="dm-chip')) {
                const firstSplit = this.documentName.split(/<span class="dm-chip" contenteditable="false">/g);
                const secondSplit = firstSplit.reduce((acc, elem, index) => {
                    if (index === 0) {
                        acc.push(elem);
                    } else {
                        const parts = elem.split("</span>");
                        this.dataModelArray.forEach(item => {
                            if (item.includes(parts[0])) {
                                parts[0] = item;
                            }
                        });
                        const newString = `\${(${parts[0]})!}`;
                        acc.push(newString);
                        acc.push(parts[1]);
                    }
                    return acc;
                }, []);
                if (this.fromDiagram) {
                    this.setDiagramFileNameWithDataModel(secondSplit.join("").replaceAll("&nbsp;", " "));
                } else {
                    this.setFileNameWithDataModel(secondSplit.join("").replaceAll("&nbsp;", " "));
                }
            } else if (this.fromDiagram) {
                this.setDiagramFileNameWithDataModel(this.filenameNoChip.replaceAll("&nbsp;", " "));
            } else {
                this.setFileNameWithDataModel(this.filenameNoChip.replaceAll("&nbsp;", " "));
            }
        }
    }

};
